import { DocumentName } from '../../../constants/documents';

export const FUNDING_PREFERENCE_TPO_WITH_MERS = 'TPO with MERS as nominee';

export const WET_SIGN_REQUIRED_MESSAGE =
  'E-signature is required to fund the loan. You must ALSO print, wet sign and mail the original. ' +
  'Your TPO points payment will be withheld until we receive the wet-signed document.';

export enum WetSignDocumentType {
  NOTE_ALLONGE = 'NOTE_ALLONGE',
  ASSIGNMENT_AND_CONVEYANCE = 'ASSIGNMENT_AND_CONVEYANCE',
}

export const WET_SIGN_DOCUMENT_TYPES = {
  [DocumentName.NOTE_ALLONGE_WET_SIGN]: WetSignDocumentType.NOTE_ALLONGE,
  [DocumentName.ASSIGNMENT_AND_CONVEYANCE_WET_SIGN]:
    WetSignDocumentType.ASSIGNMENT_AND_CONVEYANCE,
};

export const WET_SIGN_DOCUMENT_TITLES = {
  [WetSignDocumentType.NOTE_ALLONGE]: 'Note Allonge',
  [WetSignDocumentType.ASSIGNMENT_AND_CONVEYANCE]: 'Assignment and Conveyance',
};

export const isTpoWithMersLoan = (loan: any) =>
  loan?.fundingPreference === FUNDING_PREFERENCE_TPO_WITH_MERS;
